import { Nullable, WithErrors } from "../../types";
import { DynamicLoops, DynamicLoopsFromAPI } from "./types";

export const convertDynamicLoopsFromAPI = (
    dataFromAPI: Nullable<DynamicLoopsFromAPI>
): Nullable<WithErrors<DynamicLoops>> => {
    return !dataFromAPI
        ? null
        : {
              flowLimitation: {
                  measured: dataFromAPI.flow_limitation.measured,
                  threshold: dataFromAPI.flow_limitation.threshold,
                  prePostPercent: dataFromAPI.flow_limitation.pre_post_percent,
                  statusColor: dataFromAPI.flow_limitation.status_color,
                  status: dataFromAPI.flow_limitation.status,
                  parameterName: dataFromAPI.flow_limitation.label,
              },
              volumeLimitation: {
                  measured: dataFromAPI.volume_limitation.measured,
                  threshold: dataFromAPI.volume_limitation.threshold,
                  prePostPercent:
                      dataFromAPI.volume_limitation.pre_post_percent,
                  statusColor: dataFromAPI.volume_limitation.status_color,
                  status: dataFromAPI.volume_limitation.status,
                  parameterName: dataFromAPI.volume_limitation.label,
              },
          };
};

export const invertDynamicLoopsData = (
    data: DynamicLoops
): DynamicLoopsFromAPI => {
    return {
        flow_limitation: {
            measured: data.flowLimitation.measured,
            threshold: data.flowLimitation.threshold,
            pre_post_percent: data.flowLimitation.prePostPercent,
            status_color: data.flowLimitation.statusColor,
            status: data.flowLimitation.status,
            label: data.flowLimitation.parameterName,
        },
        volume_limitation: {
            measured: data.volumeLimitation.measured,
            threshold: data.volumeLimitation.threshold,
            pre_post_percent: data.volumeLimitation.prePostPercent,
            status_color: data.volumeLimitation.statusColor,
            status: data.volumeLimitation.status,
            label: data.volumeLimitation.parameterName,
        },
    };
};
